import {useSelector} from "react-redux";
import Ai from "./ai";

export function useAi() {
    const {workspaceMembershipData} = useSelector((state) => state.app);
    const activeWorkspaceId = workspaceMembershipData?.workspace?.documentId;

    const sendMessage = async ({workspaceId = activeWorkspaceId, message}) => {
        const ai = new Ai();
        return ai.chat({workspaceId, message});
    };

    return {sendMessage, activeWorkspaceId};
}
